/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExtractCharacterFromUrlRequest } from '../../models/extract-character-from-url-request';
import { ExtractCharacterFromUrlResponse } from '../../models/extract-character-from-url-response';

export interface AdminServiceExtractCharacterFromUrl$Params {
      body: ExtractCharacterFromUrlRequest
}

export function adminServiceExtractCharacterFromUrl(http: HttpClient, rootUrl: string, params: AdminServiceExtractCharacterFromUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<ExtractCharacterFromUrlResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceExtractCharacterFromUrl.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExtractCharacterFromUrlResponse>;
    })
  );
}

adminServiceExtractCharacterFromUrl.PATH = '/api/v3/gateway/admin/extract/character';
